import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1195165b&scoped=true&"
import script from "./component.js?vue&type=script&lang=js&"
export * from "./component.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1195165b&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=1195165b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1195165b",
  null
  
)

export default component.exports